import { SET_LOGIN } from "../types";
import jwtDecode from "jwt-decode";

export const loginUser = (token) => (dispatch, getState) => {
  const user = jwtDecode(token);
  localStorage.setItem("token", token);
  localStorage.setItem("user", { user: user.user });
  try {
    dispatch({
      type: SET_LOGIN,
      payload: {
        user: user,
        userAuth: user,
      },
    });
  } catch (error) {
    console.log("Error", error);
  }
};

export const logout = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
};
